import { useAgents } from '@mint-lib/ai-chat';
import { AgentAccordion } from '@mint-lib/ai-chat/components';

const AgenticAiAgentsList = () => {
  const { agentListWidgetData } = useAgents();

  return (
    <div
      aria-label="agentic-list"
      className='relative flex h-full max-h-135 [scrollbar-width:none] flex-col gap-2 overflow-y-auto p-3 before:top-0 before:right-0 before:z-focus before:hidden before:h-full before:w-full before:bg-ui-primary before:opacity-0 before:content-[""]'
    >
      {agentListWidgetData.map((card) => (
        <div key={card.agentName} className="flex shrink-0 flex-col">
          <AgentAccordion card={card} view="agentic" />
        </div>
      ))}
    </div>
  );
};
export default AgenticAiAgentsList;
